/**
 *      FRAMEWORK
 */
import React from 'react';
import ReactDOM from 'react-dom';
/**
 *      STYLES
 */
import './index.css';
/**
 *      TYPES
 */
 import './global.d.ts';
/**
 *      COMPONENTS
 */
import App from './App';
/**
 *      UTILS
 */
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
